module.exports = __webpack_public_path__ + "img/radar.1d60917b.png";